var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p404" }, [
    _c("h1", [_vm._v("Oops! 404")]),
    _vm._v(" "),
    _c("h1", [_vm._v("Sorry this page was not found")]),
    _vm._v(" "),
    _c(
      "p",
      [
        _vm._v("Go to "),
        _c("router-link", { attrs: { to: { name: "sports" } } }, [
          _vm._v("Homepage")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75002ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75002ed8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/errors/p404.vue
// module id = null
// module chunks = 